import React from "react";

function Home() {
  return (
    <div className="home">
      <div class="container">
        <div class="row align-items-center my-5">
          <div class="col-lg-7">
            <img
              class="img-fluid rounded mb-4 mb-lg-0"
              src="https://image.shutterstock.com/image-vector/computer-shop-various-parts-on-600w-569212921.jpg"
              alt=""
              width="900px"
              height="400px"
            />
          </div>
          <div class="col-lg-5">
            <h1 class="font-weight-light">Home page</h1>
            <p>
              Welcome to my store
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
